'use client'

import { useState } from 'react'
import Link from 'next/link'
import { Bars3Icon, HomeIcon, XMarkIcon } from '@heroicons/react/24/outline'
import navConfig from '../nav'
import { MagifestRegistrationButton } from '../MagifestRegistrationButton'

export function MagifestNavBar() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <nav aria-label="Magifest" className="border-b border-white/15">
      <div className="flex min-h-16 items-center justify-between gap-5">
        <Link
          href={navConfig.logo.href}
          className="flex shrink-0 items-center rounded-sm focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white"
        >
          <img
            src={navConfig.logo.src}
            alt={navConfig.logo.alt}
            className="h-8 w-auto max-w-44 object-contain"
          />
        </Link>

        <div className="hidden items-center gap-4 lg:flex">
          <ul className="flex items-center gap-1">
            <li>
              <Link
                href={navConfig.logo.href}
                aria-label="Magifest home"
                title="Magifest home"
                className="inline-flex size-9 items-center justify-center rounded-md text-white/80 transition-colors duration-200 hover:bg-white/10 hover:text-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
              >
                <HomeIcon aria-hidden="true" className="size-4.5" />
              </Link>
            </li>
            {navConfig.navLinks.map(item => (
              <li key={item.href}>
                <Link
                  href={item.href}
                  className="block rounded-md px-2.5 py-2 text-sm font-semibold text-white/80 transition-colors duration-200 hover:bg-white/10 hover:text-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
          <MagifestRegistrationButton
            placement="header"
            size="sm"
            className="shrink-0 before:hidden hover:!scale-100 active:!scale-100"
          >
            Register now
          </MagifestRegistrationButton>
        </div>

        <button
          type="button"
          onClick={() => setIsOpen(open => !open)}
          className="inline-flex size-10 cursor-pointer items-center justify-center rounded-lg border border-white/25 text-white transition-colors duration-200 hover:bg-white/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white lg:hidden"
          aria-expanded={isOpen}
          aria-controls="magifest-mobile-menu"
          aria-label={isOpen ? 'Close Magifest menu' : 'Open Magifest menu'}
        >
          {isOpen ? (
            <XMarkIcon aria-hidden="true" className="size-5" />
          ) : (
            <Bars3Icon aria-hidden="true" className="size-5" />
          )}
        </button>
      </div>

      <div
        id="magifest-mobile-menu"
        className={`${isOpen ? 'block' : 'hidden'} border-t border-white/10 pb-4 pt-3 lg:hidden`}
      >
        <ul className="grid grid-cols-2 gap-1">
          <li>
            <Link
              href={navConfig.logo.href}
              aria-label="Magifest home"
              onClick={() => setIsOpen(false)}
              className="flex items-center gap-2 rounded-lg px-3 py-2.5 text-sm font-semibold text-white/85 transition-colors duration-200 hover:bg-white/10 hover:text-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
            >
              <HomeIcon aria-hidden="true" className="size-4.5" />
              Home
            </Link>
          </li>
          {navConfig.navLinks.map(item => (
            <li key={item.href}>
              <Link
                href={item.href}
                onClick={() => setIsOpen(false)}
                className="block rounded-lg px-3 py-2.5 text-sm font-semibold text-white/85 transition-colors duration-200 hover:bg-white/10 hover:text-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
        <MagifestRegistrationButton
          placement="header"
          size="sm"
          className="mt-3 w-full before:hidden hover:!scale-100 active:!scale-100"
        >
          Register now
        </MagifestRegistrationButton>
      </div>
    </nav>
  )
}
